export interface CdnPlanOption {
  id: string;
  label: string;
  usdMonthly: number;
  requests: number;
  gb: number;
  s3CreditGb: number;
  monthlyUsd: number;
  s3CreditUsd: number;
  netUsd: number;
  requestShare: number;
  gbShare: number;
  fits: boolean;
  sessions: number;
}

export type PlanStatus = 'none' | 'ok' | 'near' | 'over';

// Mirrors CDN_HEADROOM in backend/src/utils/cdnPlan.ts: AWS emails at 80%.
const HEADROOM = 0.8;

export const planShare = (o: Pick<CdnPlanOption, 'requestShare' | 'gbShare'>) =>
  Math.max(o.requestShare, o.gbShare);

export function planStatus(o: Pick<CdnPlanOption, 'id' | 'requestShare' | 'gbShare'>): PlanStatus {
  if (o.id === 'payg') return 'none';
  const share = planShare(o);
  if (share > 1) return 'over';
  return share > HEADROOM ? 'near' : 'ok';
}

// Premium's bigger usage levels only matter when the traffic needs one or one
// is the plan in use; otherwise they would bury the four plans that count.
export function visiblePlans<T extends { id: string }>(options: T[], current: string, recommended: string): T[] {
  return options.filter((o) => !/^premium\d/.test(o.id) || o.id === current || o.id === recommended);
}

const trim = (n: number) => (Math.round(n * 10) / 10).toLocaleString('en-US');

export function fmtCount(n: number): string {
  if (n >= 1e9) return `${trim(n / 1e9)}B`;
  if (n >= 1e6) return `${trim(n / 1e6)}M`;
  if (n >= 1e4) return `${trim(n / 1e3)}k`;
  return Math.round(n).toLocaleString('en-US');
}

export const fmtGb = (gb: number): string => (gb >= 1024 ? `${trim(gb / 1024)} TB` : `${trim(gb)} GB`);
